import { Button } from "@/components/ui/baseUi/button"
import { SearchStaffInput } from "@/components/ui/forms/searchStaffInput"
import { SearchStaffInputSkeleton } from "@/components/ui/forms/searchStaffInputSkeleton"
import { cn } from "@/modules/lib/utils"
import { type SimpleFormik } from "@/typings/formik"
import { BoxLeadDraftEntity } from "@modules/boxLead/entities/boxLeadInput"
import { type BoxLeadInputKey } from "@modules/boxLead/formik/boxLeadFormik"
import { BoxStaffStatus } from "@modules/boxStaff/gateway/boxStaffDto"
import { word } from "@modules/core/utils/i18n"
import { Suspense } from "react"

export type BoxLeadFormStepOneProps = {
  handleSubmit: () => void
  onPrevious: () => void
  formik: SimpleFormik<BoxLeadDraftEntity, BoxLeadInputKey>
  getFormErrorMessage: (name: BoxLeadInputKey, errorMessage?: string) => React.JSX.Element | undefined
  disabled: boolean
}

export function BoxLeadFormStepOne({
  handleSubmit,
  onPrevious,
  formik,
  getFormErrorMessage,
  disabled,
  className,
  ...props
}: BoxLeadFormStepOneProps & React.ComponentProps<"div">) {
  return (
    <div className={cn("flex flex-col gap-8", className)} {...props}>
      <Suspense
        fallback={
          <SearchStaffInputSkeleton label={word("box.lead.form.input.madeByStaffId.label")} isRequiredInput={true} />
        }
      >
        <SearchStaffInput
          label={word("box.lead.form.input.madeByStaffId.label")}
          name="madeByStaffId"
          isRequiredInput={false}
          setFieldValue={formik.setFieldValue}
          getFieldProps={formik.getFieldProps}
          error={getFormErrorMessage("madeByStaffId")}
          filterByStatus={[BoxStaffStatus.ACCEPTED]}
        />
      </Suspense>

      <div className="mb-6 flex w-full flex-row items-center justify-center gap-2">
        <Button onClick={onPrevious} className="grow" variant="outline" size="lg">
          {word("global.cancel")}
        </Button>
        <Button onClick={handleSubmit} disabled={disabled} className="grow" variant="primary" size="lg">
          {word("global.continue")}
        </Button>
      </div>
    </div>
  )
}
